import { useDispatch, useSelector } from 'react-redux';

import { ResizeProps } from 'src/components/sidebar';
import {
  getConflictCount,
  getUntruncatedPullRequestDiffFileCount,
} from 'src/redux/pull-request/selectors';
import {
  isCommitSidebarOpen,
  updateSidebarState,
  getCommitSidebarWidth,
  getCommitSidebarTabIndex,
} from 'src/redux/sidebar';
import { SidebarTabDetails } from 'src/sections/global/components/sidebar-tabs';
import { getIsMobileHeaderActive } from 'src/selectors/global-selectors';

export const useSidebarExpandedWidth = (): number => {
  return useSelector(getCommitSidebarWidth);
};

export const useIsCollapsed = (): boolean => {
  const mobileHeaderActive = useSelector(getIsMobileHeaderActive);
  const commitSidebarOpen = useSelector(isCommitSidebarOpen);
  return mobileHeaderActive ? false : !commitSidebarOpen;
};

export const useResizeSidebar = (): ((props: ResizeProps) => void) => {
  const dispatch = useDispatch();
  return (resizeProps: ResizeProps) => {
    dispatch(
      updateSidebarState({
        isOpen: !resizeProps.isCollapsed,
        width: resizeProps.width,
        sidebarType: 'commit',
      })
    );
  };
};

export const useToggleSidebar = (): (() => void) => {
  const dispatch = useDispatch();
  return () => {
    dispatch(updateSidebarState({ sidebarType: 'commit' }));
  };
};

export const useSidebarTabsDetails = (): SidebarTabDetails => {
  const conflictsCount: number = useSelector(getConflictCount);
  const sidebarTabIndex: number = useSelector(getCommitSidebarTabIndex);
  const untruncatedFileCount: number = useSelector(
    getUntruncatedPullRequestDiffFileCount
  );
  return { conflictsCount, sidebarTabIndex, untruncatedFileCount };
};
